'use client';

import { Stack, Typography } from "@mui/material";
import { useContact } from "@/app/contexts/contact-context";
import EmailButton from "@/app/__to_be_integrated/_____components/_NEW/contact/buttons/EmailButton";
import PhoneButton from "@/app/__to_be_integrated/_____components/_NEW/contact/buttons/PhoneButton";

export default function ContactButtonsView() {
    const {
        content,
    } = useContact();

    return (
        <Stack spacing={4}>
            <Stack spacing={1}>
                <Typography variant="h3" component="h2">Kontakt</Typography>
                <Typography variant="subtitle2" component="p" sx={{ m: 0, color: 'text.primary' }}>{content?.reachability}</Typography>
            </Stack>
            <Stack spacing={2}>
                <EmailButton email={content!.emailAddress} />
                <PhoneButton phone={content!.phone} />
            </Stack>
        </Stack>
    )
}
